"use client";
import { useEffect } from "react";

export default function NotFound() {
  useEffect(() => {
    window.location.href = "https://aws.amazon.com/404";
  }, []);

  return null;
}
